import React, { type ReactNode } from 'react';
import { Modal, View, type ViewStyle, useWindowDimensions } from 'react-native';
import { isWebPlatform, webDialogOverlay } from '../utils/webLayout';
import {
  dialogCardStyle,
  isCompactWidth,
  overlayPaddingForWidth,
} from '../utils/responsiveLayout';
import { OperationFeedbackHost } from './OperationFeedbackHost';

type Props = {
  visible: boolean;
  onRequestClose: () => void;
  children: ReactNode;
  contentStyle?: ViewStyle;
};

/**
 * Full-screen on phones; centered constrained dialog on tablet, laptop, desktop, and web.
 */
export function AppDialogFrame({
  visible,
  onRequestClose,
  children,
  contentStyle,
}: Props) {
  const { width } = useWindowDimensions();
  const web = isWebPlatform();
  const asDialog = web || !isCompactWidth(width);
  const overlayPadding = overlayPaddingForWidth(width);

  return (
    <Modal
      visible={visible}
      transparent={asDialog}
      animationType={asDialog ? 'fade' : 'slide'}
      onRequestClose={onRequestClose}
    >
      {asDialog ? (
        <View style={[webDialogOverlay, { padding: overlayPadding }]}>
          <View style={[dialogCardStyle(width), contentStyle]}>{children}</View>
        </View>
      ) : (
        children
      )}
      {visible ? <OperationFeedbackHost /> : null}
    </Modal>
  );
}
